import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import api from '../lib/api';

export function ActionItems() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/dashboard/actions').then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <div data-testid="dashboard-actions">
      <p className="text-sm font-semibold text-slate-700 mb-2 flex items-center gap-1"><AlertTriangle className="h-4 w-4 text-amber-600" /> Perlu Tindakan</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {items.map((it) => (
          <button
            key={it.key}
            onClick={() => navigate(it.link)}
            className={`text-left rounded-lg border p-3 transition-colors hover:bg-hl ${it.count > 0 ? 'bg-amber-50 border-amber-300' : 'bg-white border-slate-200'}`}
            data-testid={`action-${it.key}`}
          >
            <div className={`text-2xl font-bold ${it.count > 0 ? 'text-amber-700' : 'text-slate-400'}`} style={{ fontFamily: 'JetBrains Mono, monospace' }}>{it.count}</div>
            <p className="text-xs text-slate-600 leading-tight">{it.label}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
